import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowUpRight } from "lucide-react";
import { WHATSAPP_LINK, WEBSITE_LINK } from "../i18n";

export const SiteFooter = ({ lang }) => {
  const hi = lang === "hi";
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-5 py-14">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div>
            <Link to="/" className="font-display text-4xl font-bold tracking-tight">
              CRIC<span className="gold-text">1X</span>
            </Link>
            <p className="mt-2 font-mono text-[12px] uppercase tracking-[0.3em] text-white/40">
              Play · Predict · Win
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-2 bg-wa px-6 py-3 font-display text-sm font-semibold uppercase tracking-wide text-white transition-transform hover:scale-[0.97]"
              data-testid="footer-whatsapp-cta"
            >
              <MessageCircle size={16} /> {hi ? "WhatsApp पर जॉइन करें" : "Join on WhatsApp"}
            </a>
            <a
              href={WEBSITE_LINK}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-2 border border-white/25 px-6 py-3 font-display text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:border-gold hover:text-gold"
              data-testid="footer-website-cta"
            >
              {hi ? "Cric1x.com देखें" : "Visit Cric1x.com"} <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
        <p className="mt-8 max-w-2xl text-xs leading-relaxed text-white/40">
          {hi
            ? "Cric1x मनोरंजन के लिए है। केवल 18+। ज़िम्मेदारी से खेलें। गेमिंग स्थानीय कानूनों के अधीन हो सकती है।"
            : "Cric1x is for entertainment. 18+ only. Play responsibly. Gaming may be subject to local laws."}
        </p>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-widest text-white/30">
          © {new Date().getFullYear()} Cric1x. {hi ? "सर्वाधिकार सुरक्षित।" : "All rights reserved."}
        </p>
      </div>
    </footer>
  );
};
